import { AlertCircle } from "lucide-react";
import { CopyButton } from "~/components/assistant/CopyButton";

interface ErrorMessageProps {
  errorText: string;
  traceId?: string;
}

export function ErrorMessage({ errorText, traceId }: ErrorMessageProps) {
  return (
    <div className="space-y-4 pt-2 pb-4">
      <div className="bg-red-50 border border-red-200 rounded-lg p-3">
        <div className="flex items-start gap-2">
          <div className="flex-shrink-0 mt-0.5">
            <AlertCircle className="h-4 w-4 text-red-500" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm text-red-700 leading-relaxed">
              <span className="font-medium">An error occurred while generating a response:</span>{" "}
              {errorText}
            </p>
            {traceId && (
              <div className="mt-2 pt-2 border-t border-red-200">
                <div className="flex items-center gap-2">
                  <span className="text-xs text-red-600 font-medium">Trace ID:</span>
                  <code className="flex-1 text-xs font-mono text-red-600 px-2 py-1 rounded truncate">
                    {traceId}
                  </code>
                  <CopyButton
                    text={traceId}
                    tooltipText="Copy Trace ID"
                    variant="light"
                    size="sm"
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
